import React, { useEffect, useMemo, useState } from "react"
import { Box, Grid, Paper } from "@mui/material"
import dayjs from "dayjs"
import SideBarLayout from "src/v2/layout/side-bar-layout"
import SelectComponent from "src/v2/components/select/select-component"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as FileIcon } from "src/v2/assets/icons/file-icon.svg"
import PriceService from "src/services/price-service"
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import { dispatchSnackbar } from "src/v2/components/SnackBar/snackbar-bus"
import TabelaAtualizacaoSpreads from "./components/tabela-atualizacao-spreads/tabela-atualizacao-spreads"

const TITLE = "Atualização de Spreads"

const AtualizacaoSpreadsPage = () => {
    const priceService = useMemo(() => new PriceService(), [])
    const [loading, setLoading] = useState(false)
    const [date, setDate] = useState("")
    const [dateOptions, setDateOptions] = useState([])
    const [tableKey, setTableKey] = useState(0)
    const [exportFileCsv, setExportFileCsv] = useState(() => async () => {})

    useEffect(() => {
        const loadDates = async () => {
            setLoading(true)
            try {
                const response = await priceService.getLastDatesOcurrence()
                const dates = (response.body?.data || [])
                    .map((item) => dayjs(item))
                    .filter((item) => item.isValid())
                    .sort((first, second) => second.valueOf() - first.valueOf())

                setDateOptions(
                    dates.map((item) => ({
                        value: item.format(DATE_FORMAT),
                        label: item.format(DATE_FORMAT_SHOW),
                    }))
                )
                setDate(dates[0]?.format(DATE_FORMAT) || "")
            } catch (error) {
                dispatchSnackbar(
                    "Não foi possível carregar as datas, tente novamente",
                    "error"
                )
            } finally {
                setLoading(false)
            }
        }

        loadDates()
    }, [priceService])

    const changeDate = (event) => {
        setDate(event.target.value)
        setTableKey((value) => value + 1)
    }

    const exportFile = async () => {
        if (!date) return

        setLoading(true)
        try {
            const response = await exportFileCsv()
            const blob = response.body
            const downloadUrl = window.URL.createObjectURL(blob)
            const link = document.createElement("a")

            link.href = downloadUrl
            link.download = `atualizacao-spreads-${date}.csv`
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(downloadUrl)
        } catch (error) {
            dispatchSnackbar("Tivemos um problema ao exportar os dados", "error")
        } finally {
            setLoading(false)
        }
    }

    return (
        <SideBarLayout
            title={TITLE}
            header
            loading={loading}
            disablePageScroll
            variant="v1"
            headerImage="/background/eventos_headers.jpg"
            headerPosition="1% 42%"
            headerTitle={TITLE}
        >
            <Box
                sx={{
                    mt: -2,
                    height: "calc(100dvh - 202px)",
                    maxHeight: "calc(100dvh - 202px)",
                    minHeight: 0,
                    pb: "8px",
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    gap: 2,
                }}
            >
                <Grid container sx={{ flexShrink: 0 }}>
                    <Grid item xs={12} xl={10}>
                        <Paper sx={{ p: 3 }}>
                            <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                                <Grid item xs={12} sm={6} md={3}>
                                    <SelectComponent
                                        label="Data de Referência"
                                        value={date}
                                        onChange={changeDate}
                                        options={dateOptions}
                                    />
                                </Grid>
                                <Grid item>
                                    <ButtonWithIcon
                                        size="md"
                                        icon={<FileIcon />}
                                        onClick={exportFile}
                                        disabled={!date}
                                    >
                                        Exportar CSV
                                    </ButtonWithIcon>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>

                <Paper
                    sx={{
                        flex: 1,
                        p: 3,
                        display: "flex",
                        flexDirection: "column",
                        minHeight: 0,
                        overflow: "hidden",
                    }}
                >
                    {date && (
                        <TabelaAtualizacaoSpreads
                            key={tableKey}
                            date={date}
                            loading={loading}
                            setLoading={setLoading}
                            setExportFileCsv={setExportFileCsv}
                        />
                    )}
                </Paper>
            </Box>
        </SideBarLayout>
    )
}

export default AtualizacaoSpreadsPage
